// Generated by purs version 0.13.8
"use strict";
var Control_Apply = require("../Control.Apply/index.js");
var Control_Category = require("../Control.Category/index.js");
var Data_Boolean = require("../Data.Boolean/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Number = require("../Data.Number/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Lunarbox_Data_Dataflow_Runtime = require("../Lunarbox.Data.Dataflow.Runtime/index.js");
var $$Math = require("../Math/index.js");
var RuntimeDefault = function (runtimeDefault) {
    this.runtimeDefault = runtimeDefault;
};
var Runnable = function (toRuntime) {
    this.toRuntime = toRuntime;
};
var Corunnable = function (fromRuntime) {
    this.fromRuntime = fromRuntime;
};
var toRuntime = function (dict) {
    return dict.toRuntime;
};
var runtimeDefaultRV = new RuntimeDefault(Lunarbox_Data_Dataflow_Runtime.Null.value);
var runtimeDefault = function (dict) {
    return dict.runtimeDefault;
};
var runtimeDefaultArrow = function (dictRuntimeDefault) {
    return new RuntimeDefault(function (v) {
        return runtimeDefault(dictRuntimeDefault);
    });
};
var runnableTuple = function (dictRunnable) {
    return function (dictRunnable1) {
        return new Runnable(function (v) {
            return new Lunarbox_Data_Dataflow_Runtime.Pair(toRuntime(dictRunnable)(v.value0), toRuntime(dictRunnable1)(v.value1));
        });
    };
};
var runnableString = new Runnable(Lunarbox_Data_Dataflow_Runtime["String"].create);
var runnableRuntimeValue = new Runnable(Control_Category.identity(Control_Category.categoryFn));
var runnableNumber = new Runnable(function (a) {
    if (Data_Number["isNaN"](a)) {
        return Lunarbox_Data_Dataflow_Runtime.Null.value;
    };
    if (Data_Boolean.otherwise) {
        var floorAt = function (at) {
            return function (x) {
                return $$Math.floor(x * at) / at;
            };
        };
        return Lunarbox_Data_Dataflow_Runtime["Number"].create(floorAt(1000.0)(a));
    };
    throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime.Class.Runnable (line 36, column 1 - line 41, column 41): " + [ a.constructor.name ]);
});
var runnableInt = new Runnable(function ($55) {
    return Lunarbox_Data_Dataflow_Runtime["Number"].create(Data_Int.toNumber($55));
});
var runnableBool = new Runnable(Lunarbox_Data_Dataflow_Runtime.Bool.create);
var runnableArray = function (dictRunnable) {
    return new Runnable((function () {
        var $56 = Data_Functor.map(Data_Functor.functorArray)(toRuntime(dictRunnable));
        return function ($57) {
            return Lunarbox_Data_Dataflow_Runtime.NArray.create($56($57));
        };
    })());
};
var fromRuntime = function (dict) {
    return dict.fromRuntime;
};
var overRuntimeValue = function (dictRunnable) {
    return function (dictCorunnable) {
        return function (func) {
            var $58 = Data_Maybe.maybe(Lunarbox_Data_Dataflow_Runtime.Null.value)(toRuntime(dictRunnable));
            var $59 = Data_Functor.map(Data_Maybe.functorMaybe)(func);
            var $60 = fromRuntime(dictCorunnable);
            return function ($61) {
                return $58($59($60($61)));
            };
        };
    };
};
var runnableArrow = function (dictCorunnable) {
    return function (dictRunnable) {
        return new Runnable(function (f) {
            var go = function (a) {
                var v = fromRuntime(dictCorunnable)(a);
                if (v instanceof Data_Maybe.Just) {
                    return toRuntime(dictRunnable)(f(v.value0));
                };
                if (v instanceof Data_Maybe.Nothing) {
                    return Lunarbox_Data_Dataflow_Runtime.Null.value;
                };
                throw new Error("Failed pattern match at Lunarbox.Data.Dataflow.Runtime.Class.Runnable (line 63, column 12 - line 65, column 22): " + [ v.constructor.name ]);
            };
            return new Lunarbox_Data_Dataflow_Runtime["Function"](go);
        });
    };
};
var corunnaleRuntimeValue = new Corunnable(Data_Maybe.Just.create);
var corunnableTuple = function (dictCorunnable) {
    return function (dictCorunnable1) {
        return new Corunnable(function (v) {
            if (v instanceof Lunarbox_Data_Dataflow_Runtime.Pair) {
                return Control_Apply.apply(Data_Maybe.applyMaybe)(Data_Functor.map(Data_Maybe.functorMaybe)(Data_Tuple.Tuple.create)(fromRuntime(dictCorunnable)(v.value0)))(fromRuntime(dictCorunnable1)(v.value1));
            };
            return Data_Maybe.Nothing.value;
        });
    };
};
var corunnableString = new Corunnable(function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Runtime["String"]) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
});
var corunnableNumber = new Corunnable(function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Runtime["Number"]) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
});
var corunnableBool = new Corunnable(function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Runtime.Bool) {
        return new Data_Maybe.Just(v.value0);
    };
    return Data_Maybe.Nothing.value;
});
var corunnableArrow$prime$prime = function (dictRunnable) {
    return function (dictCorunnable) {
        return function (dictRuntimeDefault) {
            return new Corunnable(function (v) {
                if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
                    return Data_Maybe.Just.create((function () {
                        var $62 = Data_Maybe.fromMaybe(runtimeDefault(dictRuntimeDefault));
                        var $63 = fromRuntime(dictCorunnable);
                        var $64 = toRuntime(dictRunnable);
                        return function ($65) {
                            return $62($63(v.value0($64($65))));
                        };
                    })());
                };
                return Data_Maybe.Nothing.value;
            });
        };
    };
};
var corunnableArrow$prime = function (dictRunnable) {
    return new Corunnable(function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
            return Data_Maybe.Just.create((function () {
                var $66 = Data_Maybe.fromMaybe(Lunarbox_Data_Dataflow_Runtime.Null.value);
                var $67 = fromRuntime(corunnaleRuntimeValue);
                var $68 = toRuntime(dictRunnable);
                return function ($69) {
                    return $66($67(v.value0($68($69))));
                };
            })());
        };
        return Data_Maybe.Nothing.value;
    });
};
var corunnableArrow = function (dictRunnable) {
    return function (dictCorunnable) {
        return new Corunnable(function (v) {
            if (v instanceof Lunarbox_Data_Dataflow_Runtime["Function"]) {
                return Data_Maybe.Just.create((function () {
                    var $70 = fromRuntime(dictCorunnable);
                    var $71 = toRuntime(dictRunnable);
                    return function ($72) {
                        return $70(v.value0($71($72)));
                    };
                })());
            };
            return Data_Maybe.Nothing.value;
        });
    };
};
var corunnableArray = function (dictCorunnable) {
    return new Corunnable(function (v) {
        if (v instanceof Lunarbox_Data_Dataflow_Runtime.NArray) {
            return Data_Traversable.traverse(Data_Traversable.traversableArray)(Data_Maybe.applicativeMaybe)(fromRuntime(dictCorunnable))(v.value0);
        };
        return Data_Maybe.Nothing.value;
    });
};
var coRunnableInt = new Corunnable(function (v) {
    if (v instanceof Lunarbox_Data_Dataflow_Runtime["Number"]) {
        return Data_Int.fromNumber(v.value0);
    };
    return Data_Maybe.Nothing.value;
});
module.exports = {
    fromRuntime: fromRuntime,
    runtimeDefault: runtimeDefault,
    toRuntime: toRuntime,
    RuntimeDefault: RuntimeDefault,
    Runnable: Runnable,
    Corunnable: Corunnable,
    overRuntimeValue: overRuntimeValue,
    runtimeDefaultRV: runtimeDefaultRV,
    runtimeDefaultArrow: runtimeDefaultArrow,
    runnableInt: runnableInt,
    coRunnableInt: coRunnableInt,
    runnableNumber: runnableNumber,
    corunnableNumber: corunnableNumber,
    runnableBool: runnableBool,
    corunnableBool: corunnableBool,
    runnableRuntimeValue: runnableRuntimeValue,
    corunnaleRuntimeValue: corunnaleRuntimeValue,
    runnableArrow: runnableArrow,
    corunnableArrow: corunnableArrow,
    "corunnableArrow'": corunnableArrow$prime,
    "corunnableArrow''": corunnableArrow$prime$prime,
    runnableString: runnableString,
    corunnableString: corunnableString,
    runnableArray: runnableArray,
    corunnableArray: corunnableArray,
    runnableTuple: runnableTuple,
    corunnableTuple: corunnableTuple
};
